export default __webpack_public_path__ + "static/media/iconRotateOut.de2652e5.svg";